module.exports = __webpack_public_path__ + "static/media/Piercing-belly-verticalsymmetry.34d86cc1.png";